import React from "react";
import { Box, Typography } from "@mui/material";

export default function TotalsBar({
  method, // 'delivery' | 'pickup'
  setupSelected,
  setupFee,
  billedDelivery,
  setupTravelOverage,
  total,
  isInsideIncludedLocality,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        gap: 3,
        flexWrap: "wrap",
      }}>
      {method === "pickup" ? (
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Pickup: Free
        </Typography>
      ) : (
        <>
          {!setupSelected && (
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              Delivery: ${billedDelivery.toFixed(2)}
            </Typography>
          )}
          {setupSelected && (
            <>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Setup: ${setupFee.toFixed(2)}
              </Typography>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                {isInsideIncludedLocality
                  ? "Delivery: included"
                  : `Travel overage: $${setupTravelOverage.toFixed(2)}`}
              </Typography>
            </>
          )}
        </>
      )}
      <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
        Total: ${total.toFixed(2)}
      </Typography>
    </Box>
  );
}
